import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3af6068"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, "投保方案", -1))
const _hoisted_3 = { class: "device-wrap" }
const _hoisted_4 = { class: "base-info van-hairline--bottom" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "保障方案", -1))
const _hoisted_6 = { class: "value" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "生效日期", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "tips" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "保障额度", -1))
const _hoisted_11 = { class: "value price-value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "保险期限", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "保障范围", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "保费金额", -1))
const _hoisted_16 = { class: "value price-value" }
const _hoisted_17 = { class: "actual-price" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "实付保费", -1))
const _hoisted_19 = { class: "value price-value" }
const _hoisted_20 = {
  key: 0,
  class: "tips"
}
const _hoisted_21 = {
  key: 0,
  class: "exit-qualituy-box"
}
const _hoisted_22 = { class: "insurant-infomation-wrap" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, "投保人信息", -1))
const _hoisted_24 = { class: "base-info" }
const _hoisted_25 = { class: "label" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "button-wrap" }

import { Button } from 'vant'
import { useRouter } from 'vue-router'
import { minus, toThousands } from '@/utils/tools'
import { onMounted, Ref, ref, computed } from 'vue'
import {
  ConfirmInsureParams,
  JijiaDeviceCardInfoListItem,
  DeviceJijiaInsuranceInfoProjectItem,
  DeviceJijiaInsuranceInfo,
  ConfirmInsureParamsWaiveInfo,
} from '@/types/insurance'
import {
  getInsuranceNameInfo,
  getInusranceEffectStr,
  judgeInsuranceHasMaterialCheck,
  getInsuranceCoverage,
  JijiaInsurancePersonalTypeMap,
  JijiaInsranceApplyParamsCompanyCertifivateTextTypeMap,
  getInsuranceCertificateTypeText,
  judgeInsuranceItemUseUbi,
} from '@/defination/insurance'
import { getActivedDayValue } from '../common'
import { commonErrorHandle } from '@/utils/error-handle'
import { confirmBuyJijiaInsurance } from '@/apis/insurance'
import { usePinanPay } from '@/compositions/insurance/usePay'
import { useInsuranceStore } from '@/compositions/insurance/index'
import { InsuranceJijiaConfirmInfoStorage } from '@/storage/insurance'
import { clearToast, showConfirmModal, showToastLoading } from '@/utils/tools'
import AppHeader from '@/components/Header.vue'
import DeviceCardInfo from '../components/device-card-info.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'
import JijiaGiveUpPopup from '../components/jijia-giveup-popup.vue'
import InsuranceFactorViewPopup from '../components/insurance-factor-view-popup.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'insurance-form-confirm',
  setup(__props) {

const $router = useRouter()
const { payHandle } = usePinanPay()
// 是否优质客户有优惠
const hasExitQualiuty = ref(false)
// 退保参数
const waiveInfo = {
  apply_file: '',
  code: '',
}
const showGiveupPopup = ref(false)
const showInsuranceViewPopup = ref(false)
const { removeInsuranceFormPageKeepAlive } = useInsuranceStore()

const deviceInfo: Ref<JijiaDeviceCardInfoListItem | null> = ref(null)
const insurantParams: Ref<ConfirmInsureParams | null> = ref(null)
const currentDeviceCycleItem: Ref<DeviceJijiaInsuranceInfo | null> = ref(null)
const jijiaInsuranceItem: Ref<DeviceJijiaInsuranceInfoProjectItem | null> = ref(null)
const hasMaterialCheck = computed(() => {
  return judgeInsuranceHasMaterialCheck(jijiaInsuranceItem.value)
})
// 是否显示UBI系数
const isShowUbiInfo = computed(() => judgeInsuranceItemUseUbi(currentDeviceCycleItem.value))
// 是否需要退款
const needRefund = computed(() => {
  return currentDeviceCycleItem.value?.exist_policy
})
// 投保人个人
const isApplicantPersonal = computed(() => {
  return insurantParams.value?.applicant_info?.personnelType === '1'
})
// 保障方案名称
const insuranceNameStr = computed(() => getInsuranceNameInfo(jijiaInsuranceItem.value).productType)
// 保险生效日期
const insuranceEffectStr = computed(() =>
  getInusranceEffectStr(currentDeviceCycleItem.value?.effect_time)
)
// 是否显示加保到期时间
const isShowReplenishmentEndTime = computed(() => {
  return currentDeviceCycleItem.value?.insurance_type === 2
})
// 加保到期时间
const replenishmentEndTime = computed(() => {
  return (currentDeviceCycleItem.value?.end_time?.split(' ')?.[0] || '') + ' 截止'
})
// 优惠金额
const discountAmount = computed(() => {
  if (!hasExitQualiuty.value) {
    return ''
  }
  return minus(
    Number(jijiaInsuranceItem.value?.premium),
    Number(jijiaInsuranceItem.value?.highQualityInfo?.premium)
  )
})
// 激活天数
const activeTimeCount = computed(() => {
  if (!currentDeviceCycleItem.value) {
    return ''
  }
  return getCurrentCycleYearEqActivateDay(currentDeviceCycleItem.value)
})
// 投保人与被保人信息列表
const insurantInfomationList = computed(() => {
  if (!insurantParams.value) {
    return []
  }
  const {
    applicant_info, // 投保人信息
    insurant_info, // 被保人信息
    isSameApplyInfo,
  } = insurantParams.value
  const isPersonal = applicant_info.personnelType === '1'
  const insurantInfoList = isSameApplyInfo
    ? []
    : [
        {
          label: '被保人类型',
          value: `${JijiaInsurancePersonalTypeMap.get(
            insurant_info.personnelType
          )}（${getInsuranceCertificateTypeText(insurant_info)}）`,
        },
        {
          label: '被保人名称',
          value: insurant_info.name,
        },
        {
          label: `被保人${
            insurant_info.personnelType === '1'
              ? '身份证号码'
              : JijiaInsranceApplyParamsCompanyCertifivateTextTypeMap.get(
                  insurant_info.certificateType
                )
          }`,
          value: insurant_info.certificateNo,
        },
      ]
  const list: Array<{
    label: string
    value: string
  }> = [
    {
      label: '投保人类型',
      value: `${JijiaInsurancePersonalTypeMap.get(
        applicant_info.personnelType
      )}（${getInsuranceCertificateTypeText(applicant_info)}）`,
    },
    { label: '投保人姓名', value: applicant_info.name },
    {
      label: `投保人${
        isPersonal
          ? '身份证号码'
          : JijiaInsranceApplyParamsCompanyCertifivateTextTypeMap.get(
              applicant_info.certificateType
            )
      }`,
      value: applicant_info.certificateNo,
    },
    { label: '邮箱地址', value: applicant_info?.email },
    { label: '被保人信息', value: isSameApplyInfo ? '同投保人' : '其他' },
    ...insurantInfoList,
    { label: '是否开票', value: applicant_info?.invoicePrintType === '01' ? '是' : '否' },
  ]
  return list
})
// 格式化金额
function formatPrice(val: string) {
  return toThousands(Number(val || 0))
}
// 获取方案当前激活时间
function getCurrentCycleYearEqActivateDay(data: DeviceJijiaInsuranceInfo) {
  return getActivedDayValue(data.equipment.eq_activate_time, new Date(data.effect_time).getTime())
}
// 查看及结构件
function checkMaterialHandle() {
  if (!hasMaterialCheck.value) {
    return
  }
  $router.push({
    name: 'insurance-jijia-check-material',
    query: {
      uav: jijiaInsuranceItem.value.eq_model.toLocaleLowerCase(),
      type: String(jijiaInsuranceItem.value?.pro_type),
    },
  })
}
// 返回修改
function back() {
  $router.go(-1)
}
// 获取退保参数
async function giveupConfirmHandle(data: ConfirmInsureParamsWaiveInfo) {
  waiveInfo.apply_file = data.apply_file
  waiveInfo.code = data.code
  confirmSubmit()
}
// 投保前退保确认
function beforeConfirmHandle() {
  if (isShowUbiInfo.value) {
    showInsuranceViewPopup.value = true
    return
  }
  if (needRefund.value) {
    showGiveupPopup.value = true
    return
  }

  confirmSubmit()
}
// 确认ubi后
function confirmCheckUbiHandle() {
  if (needRefund.value) {
    showGiveupPopup.value = true
    return
  }
  confirmSubmit()
}
// 确认投保
async function confirmSubmit() {
  try {
    await showConfirmModal({
      message: '是否确认投保?',
      className: 'repair-dialog',
    })
  } catch (error) {
    return
  }
  try {
    showToastLoading()
    const params = insurantParams.value
    if (needRefund.value) {
      params.waive_info = waiveInfo
    }
    const data = await confirmBuyJijiaInsurance({
      ...params,
    })
    removeInsuranceFormPageKeepAlive()
    payHandle({
      pay_link: data.pay_link,
      eq_sn: params.sn,
      created_at: data.created_at,
      id: data.id,
      effect_time: data.policy_start_at, // 保单生效时间
    })
    clearToast()
  } catch (error) {
    commonErrorHandle(error)
  }
}
function initPageInfo() {
  const data = InsuranceJijiaConfirmInfoStorage.get<{
    currentDeviceCycleItem: DeviceJijiaInsuranceInfo
    currentDeviceJijiaItem: DeviceJijiaInsuranceInfoProjectItem
    params: ConfirmInsureParams
    is_exist_quality: boolean
  }>()
  jijiaInsuranceItem.value = data.currentDeviceJijiaItem
  currentDeviceCycleItem.value = data.currentDeviceCycleItem
  insurantParams.value = data.params
  hasExitQualiuty.value = data.is_exist_quality
  const equipment = data.currentDeviceCycleItem?.equipment
  if (!equipment) return
  deviceInfo.value = {
    sn: equipment.eq_sn,
    headInfo: {
      name: equipment.eq_name || equipment.eq_model_name,
      img: equipment.eq_logo,
      sn: equipment.eq_sn,
      model: equipment.eq_model_name,
      activeTime: equipment.eq_activate_at,
    },
    //detailInfos: [getActiveTimeInfo(equipment.eq_activate_time)],
  }
}

onMounted(() => {
  initPageInfo()
  console.log('deviceInfo.value', deviceInfo.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "确认投保信息" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["insurance-wrap", hasExitQualiuty.value ? 'exit-qualiuty-wrap' : ''])
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (deviceInfo.value)
            ? (_openBlock(), _createBlock(DeviceCardInfo, {
                key: 0,
                data: deviceInfo.value,
                imgSize: 64,
                class: "custom-card-info van-hairline--bottom"
              }, null, 8, ["data"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(insuranceNameStr)), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, _toDisplayString(_unref(insuranceEffectStr)), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(currentDeviceCycleItem.value?.effect_time?.split(' ')[0] || '') + " (设备激活 " + _toDisplayString(_unref(activeTimeCount)) + " 天) ", 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, "￥" + _toDisplayString(formatPrice(jijiaInsuranceItem.value?.amount)), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(isShowReplenishmentEndTime) ? _unref(replenishmentEndTime) : '保险生效后 1年'), 1)
          ]),
          _createElementVNode("li", { onClick: checkMaterialHandle }, [
            _hoisted_14,
            _createElementVNode("div", {
              class: _normalizeClass(["value", _unref(hasMaterialCheck) ? 'arrow-right' : ''])
            }, _toDisplayString(_unref(getInsuranceCoverage)(jijiaInsuranceItem.value)), 3)
          ]),
          _createElementVNode("li", null, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, "￥" + _toDisplayString(formatPrice(jijiaInsuranceItem.value?.premium)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createTextVNode(" ￥" + _toDisplayString(formatPrice(
              hasExitQualiuty.value
                ? jijiaInsuranceItem.value?.highQualityInfo?.premium
                : jijiaInsuranceItem.value?.premium
            )) + " ", 1),
            (hasExitQualiuty.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, "已享受优惠 ¥" + _toDisplayString(_unref(discountAmount)), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2),
      (hasExitQualiuty.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, " 符合优质客户条件，投保进阶版可享受 ¥" + _toDisplayString(_unref(discountAmount)) + " 优惠！ ", 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("ul", _hoisted_24, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(insurantInfomationList), (item, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("div", _hoisted_25, _toDisplayString(item.label), 1),
              _createElementVNode("div", _hoisted_26, _toDisplayString(item.value), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(CommonFooterWrap, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_unref(Button), {
            class: "xa-vant-button cancel-button",
            onClick: back
          }, {
            default: _withCtx(() => [
              _createTextVNode("返回修改")
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            class: "xa-vant-button confirm-button",
            onClick: beforeConfirmHandle
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认投保")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    (_unref(needRefund))
      ? (_openBlock(), _createBlock(JijiaGiveUpPopup, {
          key: 0,
          show: showGiveupPopup.value,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showGiveupPopup).value = $event)),
          isPersonal: _unref(isApplicantPersonal),
          sn: insurantParams.value?.sn,
          needRefund: _unref(needRefund),
          onConfirm: giveupConfirmHandle
        }, null, 8, ["show", "isPersonal", "sn", "needRefund"]))
      : _createCommentVNode("", true),
    _createVNode(InsuranceFactorViewPopup, {
      show: showInsuranceViewPopup.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showInsuranceViewPopup).value = $event)),
      data: jijiaInsuranceItem.value,
      onCanNext: confirmCheckUbiHandle
    }, null, 8, ["show", "data"])
  ], 64))
}
}

})